import React, { Component } from "react";
import { observer } from "mobx-react";
import { Container, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ErrorWrapper from "~/components/wrapper/ErrorWrapper";
import LoadingWrapper from "~/components/wrapper/LoadingWrapper";
import RouteWrapper from "../../spa/component/wrapper/RouteWrapper";
import CustomerPortalStore from "../stores/CustomerPortalStore";
import "../styles/CustomerTourPage.less";
import CustomerOrCoCustomerCards from "../components/CustomerOrCoCustomerCards";
import BannerDesign from "../components/BannerDesign";
import CustomerPortalMenu from "../components/CustomerPortalMenu";

@observer
class CustomerPortalCustomPage extends Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    document.title = t("customerPortal:customerPortal");
  }

  componentDidMount() {
    const { showError, match, customerPortalStore } = this.props;
    const { customerStore } = customerPortalStore;

    customerStore.customerId = parseInt(match.params.customerId, 10);
    customerStore.load().catch(error => showError(error.message));
  }

  changeActiveItem(name) {
    const { match, redirectTo } = this.props;
    redirectTo(`/${match.params.customerId}/${name}`);
  }

  render() {
    const { customerPortalStore, page, pages } = this.props;
    const { isLoading, customerStore, coCustomer } = customerPortalStore;
    if (isLoading) {
      return <LoadingWrapper loading />;
    }

    const { customer } = customerStore;

    document.title = `${customer.firstName} ${customer.lastName} - ${page.title}`;
    return (
      <>
        <div
          id="masthead"
          className="ui inverted vertical masthead center aligned segment"
          style={{
            backgroundImage: `url(${
              page.photoUrl
                ? page.photoPathWeb
                : "https://www.urbanimmersive.com/images/masthead/tourbuzz/bg_banner_6.jpg"
            })`,
            backgroundPosition: "center",
            boxShadow: "inset 0 0 0 1000px rgba(0,0,0,.4)",
            height: "400px",
          }}
        >
          <CustomerPortalMenu
            activeItem={page.slug}
            changeActiveItemCallback={name => this.changeActiveItem(name)}
            pages={pages}
          />
          <BannerDesign activeItem={page.slug} pages={pages} />
        </div>

        <Container className="customerTourPage">
          <Grid doubling columns={2} style={{ marginTop: -100 }}>
            <Grid.Column>
              <CustomerOrCoCustomerCards customerOrCoCustomer={customer} customerLogoOnly />
            </Grid.Column>
            <Grid.Column>
              {coCustomer ? <CustomerOrCoCustomerCards customerOrCoCustomer={coCustomer} /> : null}
            </Grid.Column>
          </Grid>
          <br />
          <div key={page.key}>
            <Container>
              <div dangerouslySetInnerHTML={{ __html: page.description }} />
            </Container>
          </div>

          <div className="ui basic segment" />
        </Container>
      </>
    );
  }
}

CustomerPortalCustomPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
  }),
  page: PropTypes.object.isRequired,
  pages: PropTypes.array.isRequired,
  customerPortalStore: PropTypes.instanceOf(CustomerPortalStore),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ErrorWrapper(RouteWrapper(CustomerPortalCustomPage)));
